import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Shield } from 'lucide-react';
import styles from './Navigation.module.css';

export default function Navigation() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 10);
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	return (
		<nav className={`${styles.nav} ${isScrolled ? styles.scrolled : ''}`}>
			<div className={styles.container}>
				<Link to="/" className={styles.logo}>
					<Shield className={styles.logoIcon} />
					<span className={styles.logoText}>Ringfort Studio</span>
				</Link>

				<div className={styles.desktopNav}>
					<Link to="/" className={styles.navLink}>
						Home
					</Link>
					<Link to="/docs" className={styles.navLink}>
						Documentation
					</Link>
					<a
						href="https://play.rngfort.com"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.navLink}
					>
						Demo
					</a>
					<div className={styles.navDropdown}>
						<button className={styles.navDropdownTrigger}>
							Dashboards
							<svg
								width="12"
								height="12"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
							>
								<path d="M6 9l6 6 6-6" />
							</svg>
						</button>
						<div className={styles.navDropdownMenu}>
							<a
								href="https://admin.rngfort.com"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.navDropdownItem}
							>
								Admin Dashboard
							</a>
							<a
								href="https://operator.rngfort.com"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.navDropdownItem}
							>
								Operator Dashboard
							</a>
						</div>
					</div>
					<Link to="/docs/quickstart" className={styles.ctaButton}>
						Get Started
					</Link>
				</div>

				<button
					className={styles.menuButton}
					onClick={toggleMenu}
					aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
				>
					{isMenuOpen ? <X size={24} /> : <Menu size={24} />}
				</button>
			</div>

			{isMenuOpen && (
				<div className={styles.mobileNav}>
					<Link
						to="/"
						className={styles.mobileNavLink}
						onClick={() => setIsMenuOpen(false)}
					>
						Home
					</Link>
					<Link
						to="/docs"
						className={styles.mobileNavLink}
						onClick={() => setIsMenuOpen(false)}
					>
						Documentation
					</Link>
					<a
						href="https://play.rngfort.com"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.mobileNavLink}
						onClick={() => setIsMenuOpen(false)}
					>
						Demo
					</a>
					<a
						href="https://admin.rngfort.com"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.mobileNavLink}
						onClick={() => setIsMenuOpen(false)}
					>
						Admin Dashboard
					</a>
					<a
						href="https://operator.rngfort.com"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.mobileNavLink}
						onClick={() => setIsMenuOpen(false)}
					>
						Operator Dashboard
					</a>
					<Link
						to="/docs/quickstart"
						className={styles.mobileCta}
						onClick={() => setIsMenuOpen(false)}
					>
						Get Started
					</Link>
				</div>
			)}
		</nav>
	);
}
